import { Box, Flex, Menu, MenuButton, MenuItem, MenuList, useColorMode, Spacer } from "@chakra-ui/react";
import React, { useState, useEffect, useContext, useMemo, memo } from "react";
import { Badge, IconButton, Tooltip, Typography, Grid, Chip, Button } from "@mui/material";
import NotificationsIcon from '@mui/icons-material/Notifications';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import LogoutIcon from '@mui/icons-material/Logout';
import KeyIcon from '@mui/icons-material/Key';
import ModalChangePass from "../components/login/ModalChangePass";
import { useNavigate } from 'react-router-dom';
import { account } from "./Utils";
import { ModalComponent } from "../app/common/ModalComponent";
import { HubConnectionBuilder, LogLevel, HttpTransportType } from '@microsoft/signalr'
import { Catalogos } from "../app/util/catalogos"
import { RootStoreContext } from "../app/store/root";
import { observer } from "mobx-react-lite";
import { EnumStatusShipment, EnumStatusEmbarque } from "./Enumerables";
import ModalDetalles from "../shared/modals/ModalDetalles"
import { getColorEstatusEmbarque, getColorEstatusEnvio } from "../app/util/util";
import ModalDetalleEmbarque from '../shared/modals/ModalDetalleEmbarque';
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DialogComponent from "../app/common/DialogComponent";
import { EnumPerfiles } from "../shared/Enumerables";
import InfiniteScroll from 'react-infinite-scroller';


const NavbarLinks = (props) => {
    const navigate = useNavigate();
    const {
        variant,
        children,
        fixed,
        scrolled,
        onOpen,
        routes,
        ...rest
    } = props;

    const rootStore = useContext(RootStoreContext);
    const {
        leerAlertasUsuario: _leerAlertasUsuario,
        cerrarAlertasUsuario: _cerrarAlertasUsuario,
        getEmbarqueById,
        setEntityEmbarque
    } = rootStore.embarqueStore;

    const {
        getAlertasUsuario: _getAlertasUsuario
    } = rootStore.usuarioStore;

    const {
        leerAlertasUsuario: _leerAlertasUsuarioGuia,
        cerrarAlertasUsuario: _cerrarAlertasUsuarioGuia,
        getById,
    } = rootStore.shipmentStore;

    const [alertasUsuario, setAlertasUsuario] = useState([])
    const [notifications, setNotifications] = useState([])
    const [showConfirmCerrar, setShowConfirmCerrar] = useState(false)

    const joinNotifications = async () => {
        try {
            const connection = new HubConnectionBuilder()
                .withUrl(`${process.env.REACT_APP_API_LOGISTICA}/notification`, {
                    skipNegotiation: true,
                    transport: HttpTransportType.WebSockets
                })
                .configureLogging(LogLevel.Information)
                .withAutomaticReconnect()
                .build();

            let dataUser = account.getDatosUsuario()
            if (dataUser.perfil?.toUpperCase() == EnumPerfiles.Administrador
                || dataUser.perfil?.toUpperCase() == EnumPerfiles.Empleado) {
                connection.on("NotificacionEmpresa", (message) => {                    
                    getAlertasUsuario()
                })
            }
            if (dataUser.perfil?.toUpperCase() == EnumPerfiles.Proveedor) {
                connection.on("NotificacionProveedor", (message) => {                    
                    getAlertasUsuario()
                })
            }
            await connection.start()
            //await connection.invoke("")
        } catch (error) {
            console.log({ error })
        }
    }

    useEffect(() => {
        joinNotifications()
        getAlertasUsuario()
    }, []);

    let navbarIcon = fixed && scrolled ? "gray" : "white";
    let menuBg = "white";
    let bgChip = "";
    const btnRef = React.useRef();

    //DIALOG DETALLE
    const [openDetalleGuia, setOpenDialogDetalleGuia] = useState(null);
    const [openDetalleEmbarque, setOpenDetalleEmbarque] = useState(null);

    const mostrarModalDetalleItem = async (data) => {
        if (!data.esMovimientoEmbarque) {
            await getById(data.idGuia)
            setOpenDialogDetalleGuia(true)
        } else {
            let resp = await getEmbarqueById(data.idEmbarque)
            if (resp != null) {
                setEntityEmbarque(resp)
                setOpenDetalleEmbarque(true)
            }
        }
    }

    const closeDialogDetalle = (reason) => {
        if (reason && reason == "backdropClick")
            return;
        setOpenDialogDetalleGuia(null);
    }

    const closeDialogDetalleEmbarque = (reason) => {
        if (reason && reason == "backdropClick")
            return;
        setOpenDetalleEmbarque(false)
    }

    const getAlertasUsuario = async () => {
        // let notificaciones = await _getAlertasUsuario()
        // if (notificaciones.data) {
        //     setAlertasUsuario(notificaciones.data)

        //     const ListItem = getNotificaciones(notificaciones.data)
        //     // const ListItem = getNotificaciones(notificaciones.data);

        //     setNotifications(ListItem);
        // }
    }



    const cerrarAlertasUsuario = async (data) => {

        let idMovimientos = [data.idMovimiento]
        if (data.esMovimientoEmbarque) {
            await _cerrarAlertasUsuario(idMovimientos)
        } else {
            await _cerrarAlertasUsuarioGuia(idMovimientos)
        }
        getAlertasUsuario()
    }

    const leerTodas = async () => {
        let idMovimientoEnvio = alertasUsuario.filter(a => !a.esMovimientoEmbarque).map(a => { return a.idMovimiento })
        let idMovimientoEmbarque = alertasUsuario.filter(a => a.esMovimientoEmbarque).map(a => { return a.idMovimiento })
        if (idMovimientoEnvio.length > 0) {
            let resp = await _leerAlertasUsuarioGuia(idMovimientoEnvio)
        }
        if (idMovimientoEmbarque.length > 0) {
            let resp2 = await _leerAlertasUsuario(idMovimientoEmbarque)
        }
        getAlertasUsuario()
    }

    const cerrarAlertasUsuarioTodas = async () => {
        let idMovimientoEnvio = alertasUsuario.filter(a => !a.esMovimientoEmbarque).map(a => { return a.idMovimiento })
        let idMovimientoEmbarque = alertasUsuario.filter(a => a.esMovimientoEmbarque).map(a => { return a.idMovimiento })
        if (idMovimientoEnvio.length > 0) {
            let resp = await _cerrarAlertasUsuarioGuia(idMovimientoEnvio)
        }
        if (idMovimientoEmbarque.length > 0) {
            let resp2 = await _cerrarAlertasUsuario(idMovimientoEmbarque)
        }
        getAlertasUsuario()
    }

    const clickMarcarLecturaItem = async (prop) => {
        if (prop.esMovimientoEmbarque) {
            await _leerAlertasUsuario([prop.idMovimiento])
        } else {
            await _leerAlertasUsuarioGuia([prop.idMovimiento])
        }
        getAlertasUsuario()
    }

    // const ListItem = memo(({ item }) => {
    //     console.log('Rendering:', item); // For debugging purposes
    //     return <li>{item}</li>;
    //   });


    //   const getNotificaciones = (notificaciones) => {
    //     //HACER VALIDACIONES PARA MOSTRAR LAS NOTIFICACIONES
    //     // const handleMenuItemClick = (event, index) => {
    //     // };

    //     const resultMemo = memo(() => {
    //         return notificaciones.map((prop, index) => {
    //             switch (prop.idEstatus) {
    //                 case EnumStatusShipment.Recibido:
    //                     bgChip = "recibido"
    //                     break;
    //                 case EnumStatusEmbarque.Creado:
    //                     bgChip = "documentado"
    //                     break;
    //                 case EnumStatusEmbarque.En_Transito:
    //                     bgChip = "transito"
    //                     break;
    //                 case EnumStatusEmbarque.Entregado:
    //                     bgChip = "entregado"
    //                     break;
    //                 case EnumStatusEmbarque.No_Entregado:
    //                     bgChip = "noEntregado"
    //                     break;
    //                 default:
    //                     bgChip = "recibido"
    //                     break;
    //             }
    //             return (
    //                 <MenuItem mb={'10px'} borderRadius='8px' width={"100%"}>
    //                     <Flex direction={'column'} width={"inherit"}>
    //                         <Box mb={'5px'} bg={prop.leida ? '#DDD9DF' : 'white'} >
    //                             <Grid container direction={'column'}>
    //                                 <Grid item xs={'auto'} display={'flex'} justifyContent={'end'} marginRight={"1.5em"}>
    //                                     <IconButton onClick={(e) => clickMarcarLecturaItem(prop)} variant='closeIcon'>
    //                                         <CheckIcon />
    //                                     </IconButton>
    //                                     <IconButton onClick={(e) => cerrarAlertasUsuario(prop)} variant='closeIcon'>
    //                                         <CloseIcon />
    //                                     </IconButton>
    //                                 </Grid>
    //                                 <div onDoubleClick={(e) => mostrarModalDetalleItem(prop)}>
    //                                     <Grid item container direction={'column'} >
    //                                         <Typography variant="h6">
    //                                             {prop.esMovimientoEmbarque ? 'No de carta porte' : 'No de guía'} #{prop.esMovimientoEmbarque ? prop.numeroCartaPorte : prop.numeroGuia}
    //                                         </Typography>
    //                                         <Grid item container direction={'row'} justifyContent="space-between" alignItems={"center"} gap={2}>
    //                                             <Typography>
    //                                                 El envío cambio de estatus a
    //                                             </Typography>
    //                                             <Chip sx={{ marginRight: '1.5em' }} label={prop.estatus} color={prop.esMovimientoEmbarque ? getColorEstatusEmbarque(prop.estatus) : getColorEstatusEnvio(prop.estatus)} />
    //                                         </Grid>
    //                                     </Grid>
    //                                 </div>
    //                             </Grid>
    //                         </Box>
    //                         <Flex h="1px" w="100%" bg="gray"> </Flex>
    //                     </Flex>
    //                 </MenuItem>
    //             );
    //         });
    //     },notificaciones.data);
        
    //     return resultMemo;
    // }


    const getNotificaciones = (notificaciones) => {
        //HACER VALIDACIONES PARA MOSTRAR LAS NOTIFICACIONES
        // const handleMenuItemClick = (event, index) => {
        // };
        
        return notificaciones.map((prop, index) => {
            switch (prop.idEstatus) {
                case EnumStatusShipment.Recibido:
                    bgChip = "recibido"
                    break;
                case EnumStatusEmbarque.Creado:
                    bgChip = "documentado"
                    break;
                case EnumStatusEmbarque.En_Transito:
                    bgChip = "transito"
                    break;
                case EnumStatusEmbarque.Entregado:
                    bgChip = "entregado"
                    break;
                case EnumStatusEmbarque.No_Entregado:
                    bgChip = "noEntregado"
                    break;
                default:
                    bgChip = "recibido"
                    break;
            }
            return (
                <MenuItem mb={'10px'} borderRadius='8px' width={"100%"}>
                    <Flex direction={'column'} width={"inherit"}>
                        <Box mb={'5px'} bg={prop.leida ? '#DDD9DF' : 'white'} >
                            <Grid container direction={'column'}>
                                <Grid item xs={'auto'} display={'flex'} justifyContent={'end'} marginRight={"1.5em"}>
                                    <IconButton onClick={(e) => clickMarcarLecturaItem(prop)} variant='closeIcon'>
                                        <CheckIcon />
                                    </IconButton>
                                    <IconButton onClick={(e) => cerrarAlertasUsuario(prop)} variant='closeIcon'>
                                        <CloseIcon />
                                    </IconButton>
                                </Grid>
                                <div onDoubleClick={(e) => mostrarModalDetalleItem(prop)}>
                                    <Grid item container direction={'column'} >
                                        <Typography variant="h6">
                                            {prop.esMovimientoEmbarque ? 'No de carta porte' : 'No de guía'} #{prop.esMovimientoEmbarque ? prop.numeroCartaPorte : prop.numeroGuia}
                                        </Typography>
                                        <Grid item container direction={'row'} justifyContent="space-between" alignItems={"center"} gap={2}>
                                            <Typography>
                                                El envío cambio de estatus a
                                            </Typography>
                                            <Chip sx={{ marginRight: '1.5em' }} label={prop.estatus} color={prop.esMovimientoEmbarque ? getColorEstatusEmbarque(prop.estatus) : getColorEstatusEnvio(prop.estatus)} />
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Box>
                        <Flex h="1px" w="100%" bg="gray"> </Flex>
                    </Flex>
                </MenuItem>
            );
        });
    }

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClose = () => {
        setAnchorEl(null);
    };

    //DIALOG CHANGE PASS
    const [openPass, setOpenDialogPass] = React.useState(false);

    const openDialogPass = () => {
        setOpenDialogPass(true);
        handleClose();
    };

    const closeDialogPass = (event, reason) => {
        if (reason && reason == "backdropClick")
            return;
        setOpenDialogPass(null);
    };

    var UltEmbarque =  localStorage.removeItem("LastEmbarque");   

    // const fetchItems = async (page, limit) => {
    //     // Simulate an API call to fetch items
    //     return new Promise((resolve) => {
    //       setTimeout(() => {
    //         const newItems = Array.from({ length: limit }, (_, i) => `Item ${page * limit + i + 1}`);
    //         resolve(newItems);
    //       }, 1000); // Simulate network delay
    //     });
    //   };

    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [items, setItems] = useState([]);
    const itemsPerPage = 20;


    const cerrarSesion = () => {
         
        
        setShowConfirmCerrar(false)
        if(UltEmbarque){
            account.removeUltEmbarque()
        }
        account.removeToken()
        account.removeDatosUsuario()
        navigate('/')
    }

 



    return (
        <>
            <Flex
                pe={{ sm: "0px", md: "16px" }}
                w={{ sm: "100%", md: "auto" }}
                alignItems="center"
                flexDirection="row" gap={6}>
                <Typography variant="userName" color={navbarIcon}>
                    {account.getNombreUsuario()}
                </Typography>

                <Menu sx={{ zIndex: 1 }} closeOnSelect={false}>
                    <Tooltip title="Notificaciones">
                        <MenuButton>
                            <Badge badgeContent={alertasUsuario.filter(a => !a.leida)?.length?.toString()} color="error">
                                <NotificationsIcon sx={{ color: navbarIcon, fontSize: '1.3rem' }} />
                            </Badge>
                        </MenuButton>
                    </Tooltip>
                    {(notifications.length > 0) &&
                        <MenuList p="17px 0px" bg={menuBg} width="330px" sx={{ boxShadow: '0px 0px 15px 5px rgba(0,0,0,0.49)' }}>
                            <Box mt={"5px"}>
                                <Button onClick={(e) => leerTodas()} variant="text" sx={{ width: '50%' }}>Leer todas</Button>
                                <Button onClick={(e) => cerrarAlertasUsuarioTodas()} variant="text" sx={{ width: '50%' }}>Cerrar todas</Button>
                            </Box>
                            <Flex flexDirection="column" sx={{ maxH: '60vh', overflow: 'overlay' }} p="0px 15px">
                                {/* {notifications} */}
                                <InfiniteScroll pageStart={0} loadMore={() => {setPage(prevPage => prevPage + 1);}} hasMore={page * itemsPerPage < notifications.length} loader={<div key={0}>Loading...</div>}>
                                    <ul>
                                    {notifications.map((item, index) => (
                                    <li key={index}>{item}</li>
                                    ))}
                                    </ul>
                                </InfiniteScroll>
                            </Flex>

                        </MenuList>
                    }
                </Menu>

                <Spacer />
                <Tooltip title="Rastrear Envío">
                    <IconButton
                        sx={{ color: navbarIcon, fontSize: "1.3rem" }}
                        onClick={() => navigate("/Rastreo")}
                    >
                        <LocalShippingIcon ref={btnRef} />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Cambiar Contraseña">
                    <IconButton onClick={openDialogPass} sx={{ color: navbarIcon, fontSize: '1.3rem' }}>
                        <KeyIcon />
                    </IconButton>
                </Tooltip>
                <Spacer />
                <Tooltip title="Cerrar Sesión">
                    <IconButton sx={{ color: navbarIcon, fontSize: '1.3rem' }} onClick={(e) => setShowConfirmCerrar(true)}>
                        <LogoutIcon />
                    </IconButton>
                </Tooltip>
            </Flex>
            <DialogComponent
                Open={showConfirmCerrar}
                Message="¿Seguro que desea salir?"
                OnClose={() => setShowConfirmCerrar(false)}
                OnAccept={() => {
                    cerrarSesion()
                }}
            />
            <ModalComponent
                Open={openPass}
                HandleClose={() => closeDialogPass}
                ClassName="modal-st"
                Body={() => (
                    <ModalChangePass
                        onClose={closeDialogPass}
                    />
                )}
            />
            <ModalComponent
                Open={openDetalleGuia}
                HandleClose={() => closeDialogDetalle(false)}
                ClassName="modal-xl"
                Body={() => (
                    <ModalDetalles
                        onClose={closeDialogDetalle}
                    />
                )}
            />
            <ModalComponent
                Open={openDetalleEmbarque}
                HandleClose={() => closeDialogDetalleEmbarque(false)}
                ClassName="modal-xl"
                Body={() => (
                    <ModalDetalleEmbarque
                        onClose={(e) => {
                            e.preventDefault()
                            closeDialogDetalleEmbarque(false)
                        }}
                    />
                )}
            />
        </>
    );
}

export default observer(NavbarLinks)
